import React, { useState } from 'react';
import { Typography, Tooltip } from '../../components';
import { CopyOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import './InfoRow.scss';

const { Text } = Typography;

export const InfoRow = ({ label, value, copyable = false, tooltipThreshold = Infinity }) => {
    const [copied, setCopied] = useState(false);
    const shouldShowTooltip = value?.length > tooltipThreshold;
    const valueClassName = classNames({ 'truncate-value': shouldShowTooltip });

    const handleCopy = () => {
        if (value) {
            navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), 1000);
        }
    };

    return (
        <div className="info-row">
            <Text>
                {label && <span className="info-row-label text-light">{label}:</span>}
                {shouldShowTooltip ? (
                    <Tooltip title={value}>
                        <span className={`info-row-value ${valueClassName}`}>{value}</span>
                    </Tooltip>
                ) : (
                    <span className={`info-row-value ${valueClassName}`}>{value}</span>
                )}
                {copyable && (
                    <Tooltip title="Copied" open={copied}>
                        <CopyOutlined className="copy-icon" onClick={handleCopy} />
                    </Tooltip>
                )}
            </Text>
        </div>
    );
};
